module.exports = {"id":"193983","name":"Andy Delort","rating":"75","photo":"./data/images/photos/3/193983.png","club":{"name":"Toulouse FC","logo":"./data/images/clubs/ToulouseFC.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndyDelort0.json
// module id = 407
// module chunks = 0